export default "__VITE_ASSET__BIAogRmy__"